import {
	BankAccountEntityType,
	SupabaseTableEnum,
} from "@/lib/supabase/supabaseTypes";
import { CustomSelectShadcn } from "../../../../components/custom-select-shadcn.component";
import { useFetchEntriesByOrganizationId } from "../../../../hooks/fetch-hooks/useFetchEntriesByOrganizationId";
import { SelectProps } from "../../../form-types";

interface BankAccountSelectProps extends SelectProps {
	helperText?: string;
}

/**
 * BankAccountSelect - select component for bank accounts
 * @param onChange - function to call when the value changes
 * @param value - the current value 
 * @example 
 * <BankAccountSelect 
 *    onChange={(value: number) => handleValueChange("bank_account_id", value)}
 *    value={formData.bank_account_id}
    />
 */
export const BankAccountSelect: React.FC<BankAccountSelectProps> = (props) => {
	const { rows: bankAccounts } = useFetchEntriesByOrganizationId(
		SupabaseTableEnum.BANK_ACCOUNTS
	);

	const options =
		bankAccounts?.map((account: BankAccountEntityType) => ({
			value: account.id,
			label: account.account_name ?? account.bank_name ?? "",
		})) ?? [];

	return (
		<CustomSelectShadcn
			options={options}
			inputLabel="Konto"
			value={props.value}
			onChange={(value) => props.onChange(value?.toString() || null)}
			disabled={props.disabled}
			densitySize={props.densitySize}
			inputHeight={props.inputHeight}
			width={props.width}
			required={props.required}
			validationError={props.validationError}
			helperText={props.helperText}
		/>
	);
};
